/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useLocation } from "react-router-dom";
import  { useState, useEffect } from "react";
import { TrullySdkWeb } from "@trully/trully-sdk-react";
import logo from "./assets/logo.png";
import PermissionModal from "./PermissionModal";
import * as Sentry from '@sentry/react';
import "@trully/trully-sdk-react/dist/index.css";
import "./App.css";

const App = () => {
  // const location = useLocation();

  // const getUserIdFromUrl = () => {
  //   const searchParams = new URLSearchParams(location.search);
  //   const pathParts = location.pathname.split("/");
  //   const queryUid = searchParams.get("withuid");
  //   if (queryUid) return queryUid;
  //   const withuidIndex = pathParts.findIndex((part) =>
  //     part.startsWith("withuid=")
  //   );
  //   if (withuidIndex !== -1) {
  //     return pathParts[withuidIndex].split("=")[1];
  //   }
  //   return null;
  // };

  // const getRequestIdFromUrl = () => {
  //   const searchParams = new URLSearchParams(location.search);
  //   return searchParams.get("withrequestid=") || "";
  // };

  // const userId = getUserIdFromUrl();
  // const requestId = getRequestIdFromUrl();
  // if (userId === null) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen bg-white">
  //       <div className="text-center">
  //         <img src={logo} alt="Logo" width={200} />
  //       </div>
  //     </div>
  //   );
  // }
  const [permissionStatus, setPermissionStatus] = useState('idle');
  const [currentStream, setCurrentStream] = useState<MediaStream | null>(null);

  useEffect(() => {
    // Check permission status periodically
    const checkPermissionStatus = async () => {
      try {
        if (navigator.permissions) {
          const permissionStatus = await navigator.permissions.query({ name: 'camera' as PermissionName });
          
          permissionStatus.onchange = () => {
            switch(permissionStatus.state) {
              case 'granted':
                setPermissionStatus('granted');
                break;
              case 'denied':
                if (currentStream) {
                    currentStream?.getTracks().forEach((track: MediaStreamTrack) => track.stop());
                  setCurrentStream(null);
                }
                setPermissionStatus('denied');
                break;
              case 'prompt':
                setPermissionStatus('idle');
                break;
              default:
                setPermissionStatus('idle');
            }
          };
        }
      } catch (error) {
        Sentry.captureException(`Permission status check error: ${error}`);
      }
    };

    // Only run if permission was previously granted
    if (permissionStatus === 'granted') {
      checkPermissionStatus();
    }

    if (typeof window.FileReader === 'undefined'){
      setPermissionStatus('denied');
      Sentry.captureException(`FileReader is not supported, lockdown mode might be activated`);
    }

    // Cleanup listener
    return () => {
      if (currentStream) {
        currentStream.getTracks().forEach(track => track.stop());
      }
    };
  }, [currentStream, permissionStatus]);

  const requestCameraPermission = async () => {
    try {
      // Check if the browser supports mediaDevices
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // Request camera permission
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        
        // Save the stream
        setCurrentStream(stream);
        
        // Permission granted
        setPermissionStatus('granted');
      } else {
        // Browser doesn't support getUserMedia
        setPermissionStatus('unsupported');
      }
    } catch (error) {
      // Permission denied or error occurred
      console.error('Camera permission error:', error);
      setPermissionStatus('denied');
      throw new Error(`Camera permission error: ${error}`, );
    }
  };

  const sdkConfig = {
    isDev: import.meta.env.VITE_TRULLY_DEV_MODE === "true",
    images: {
      logo: logo,
    },
    styles: {
      textsStyles: {
        primaryTextColor: "#1E6091",
        secondaryTextColor: "#1E6091",
      },
    },
    apiKey: import.meta.env.VITE_TRULLY_API_KEY,
    // user_id: userId ? userId : "",
    showLogo: true,
    termsAndConditions: "https://www.trully.ai/t%C3%A9rminos-y-condiciones/",
    privacyPolicy: "https://www.trully.ai/politica-de-datos/",
    handleData: (response: any) => {
      console.log("Trully SDK Response:", response);
      console.log("TIMESTAMP", new Date().toISOString());
      // Send message to React Native WebView if it exists
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "SDK_RESPONSE",
            response: response,
          })
        );
      }
    },
    handleError: (error: any) => {
      console.error("Trully SDK Error:", error);
      // Optionally notify React Native of errors
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "SDK_ERROR",
            error: error,
          })
        );
      }
    },
  };

  return <>
  {
    permissionStatus !== 'granted' ? (
      <PermissionModal requestPermission={requestCameraPermission}/>
    )
    :
    (
      <TrullySdkWeb configuration={sdkConfig} />
    )
  }
  </>
};

// Add TypeScript declaration for ReactNativeWebView
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage(message: string): void;
    };
  }
}

export default App;
